export default __webpack_public_path__ + "static/media/right-arrow.b83e3f92.svg";